// Initialize navigation bar (jump_to and languages)
// called by: //app/assets/javascripts/documentation.js.coffee
//
// Based on permitted languages configured in setupPermittedLanguages()
// update the language nav bar and show if more than one language permitted
// this module determines each components visibility and returns Array

export default function setupLanguageNavigation(permittedLanguages = null) {
  const languageItems = 'menu[type="toolbar"] > li[data-lang]';
  const jumpItems = 'a[data-jump-menu-link]';

  // If there are no permitted langs don't traverse the DOM
  const languageList =
    !permittedLanguages || !permittedLanguages.length
      ? []
      : Array.from(document.querySelectorAll(languageItems))
          .map(li => {
            const lang = li.dataset.lang || '';
            const permitted = permittedLanguages.indexOf(lang) + 1;

            li.style.display = permitted ? 'block' : 'none';
            return permitted ? lang : null;
          })
          .filter(lang => lang);

  const jumpList = Array.from(document.querySelectorAll(jumpItems))
    .map(a => a.href.replace(/^[^#]+#/, '')) // hash value
    .filter(hash => hash && hash.trim());

  return [jumpList, languageList];
}
